import { render, staticRenderFns } from "./drivers-base-info-form.vue?vue&type=template&id=d4a55f8e&scoped=true&"
import script from "./drivers-base-info-form.vue?vue&type=script&lang=js&"
export * from "./drivers-base-info-form.vue?vue&type=script&lang=js&"
import style0 from "./drivers-base-info-form.vue?vue&type=style&index=0&id=d4a55f8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a55f8e",
  null
  
)

export default component.exports